import React from 'react';
import DocumentTitle from 'react-document-title';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const baseTitle = (window.document && window.document.title) || import.meta.env.VITE_APP_NAME;

function formatTitle(pageTitle) {
  return pageTitle ? `${pageTitle} - ${baseTitle}` : baseTitle;
}

/**
 * @param {Object} props
 * @param {string} props.title This can be a string or the id for a translation.
 * @param {*} props.children
 * @param {*} props.intl Ignore.
 */
const PageTitle = ({ title, children, intl }) => (
  <DocumentTitle title={formatTitle(intl.formatMessage({ id: title }))}>{children}</DocumentTitle>
);

PageTitle.defaultProps = {
  children: null
};

PageTitle.propTypes = {
  intl: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default injectIntl(PageTitle);
